<template>
    <div>
      <div class="container">
        <div class="crumbs" style="margin-bottom:30px;">
          {{title}}
        </div>
        <el-form :inline="true" :model="query" ref="query">
          <el-form-item label="审批流程名称" prop="auditName">
            <el-input
              v-model="query.auditName"
              placeholder="请输入审批流程名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="创建人" prop="createMemberName">
            <el-input
              v-model="query.createMemberName"
              placeholder="请输入创建人"
            ></el-input>
          </el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button type="primary" @click="handleClear">重置</el-button>
        </el-form>
      </div>
      <div class="container">
        <div style="margin-bottom: 20px">
          <el-button
            type="primary"
            @click="goToUrl('/createApprove')"
            style="float: right; margin-bottom: 20px"
            >新增审批流程</el-button
          >
        </div>
  
        <TableList
          :loading="loading"
          :table-data="tableData"
          :table-label="tableLabel"
          :table-option="tableOption"
          :row-key="rowKey"
          @handleButton="handleButton"
          @handleSortChange="handleSortChange"
        >
          <template v-slot:index="slot">
            {{ slot.scope.$index + 1 }}
          </template>
        </TableList>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="productTagPage.pageNum"
            :page-size="productTagPage.pageSize"
            :total="productTagPage.pageTotal"
            prev-text="上一页"
            next-text="下一页"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import TableList from "../../../components/common/e-table-list";
  import CompnanyApi from '../../../api/company/index.js';
  import Api from "../../../api/approve/index";
  export default {
    name: "",
    components: {
      TableList,
    },
    props: {
        title:{
            type: String,
            required:true
        },
        type:{
            type:Number,
            required:true
        }
    },
    data () {
      return {
        query: {
            auditName: "",
            createMemberName:''
        },
        loading: false,
        tableData: [],
        tableLabel: [
          {
            label: "审批流程名称",
            param: "auditName",
            align: "center",
          },
          {
            label: "审批流程说明",
            param: "remake",
            align: "center",
          },
          { label: "审批流程创建人", param: "createMemberName", align: "center" },
          { label: "审批流程创建时间", param: "createTime", align: "center" },
        ],
        rowKey: 'workflowDefinitionId',
        tableOption: {
          label: "操作",
          width: "300",
          fixed: "right",
          permission: '0',
          options: [
            {
              label: "编辑",
              type: "text",
              methods: "handleEdit",
            },
            {
              label: "删除",
              type: "text",
              methods: "handleDelete",
            },
          ],
        },
        productTagPage: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 0,
        },
        addUserDialogShow: false,
        resetPasswordShow: false,
        dialogTitle: "",
        checkUserShow: false,
        userData: {},
        switchFlag:true
      };
    },
    computed: {},
    created () {
      this.getWorkflowList();
    },
    watch: {
      // 利用watch方法检测路由变化：
      '$route': function() { 
        this.getWorkflowList();
     
    },
},
    methods: {
  
      // 查询
      handleSearch () {
        this.productTagPage.pageNum = 1;
        this.productTagPage.pageSize = 10;
        this.getWorkflowList();
      },
      // 重置
      handleClear () {
        this.query.auditName = "";
        this.query.createMemberName = ''
        this.productTagPage.pageNum = 1
        this.productTagPage.pageSize =10
        this.getWorkflowList();
      },
  
      // 删除审批流
      handleDelete (val) {
        if(this.tableData.length == 1){
          this.$confirm("该审批流程将被删除，且审批流启用状态将被关闭，是否继续？", "提示", {
          confirmButtonText: "继续删除",
          cancelButtonText: "取消",
          // type: "warning",
        })
          .then(() => {
            if (this.title === '询比价选商定价审批') {
              this.saveOrderAskPrice();
            } else {
              this.saveApprovalSwitch()
            }
            this.removeApprove(val);
          })
          .catch(() => {
            this.$message.info("已取消删除");
          });
        }else{
          this.handleDeleteOk(val);
        }
      },

      async removeApprove(val) {
        let auditIdList = []
        auditIdList.push(val.row.auditId)
        await Api.removeApprove({auditIdList: auditIdList,}).then((res) => {
          if (res.code == "200") {
            if (!this.tableData.length) {
              this.flag = false;
            }
            this.$message.success("删除成功!");
            this.getWorkflowList();
          }
        });
      },

      // 删除审批流程
      handleDeleteOk(val) {
        this.$confirm("该审批流程将被删除，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.removeApprove(val);
          })
          .catch(() => {
            this.$message.info("已取消删除");
          });
      },
  
      // 查询审批流
      getWorkflowList () {
        let params = {
          auditName: this.query.auditName,
          createMemberName:this.query.createMemberName,
          pageSize: this.productTagPage.pageSize,
          pageNum: this.productTagPage.pageNum,
        };
        if(this.type === 6){
          params.auditTypeList = [4,6];
        }else{
          params.auditType = this.type;
        }
        Api.listWorkflow(params).then((res) => {
          this.productTagPage.pageTotal = res.data.total;
          this.tableData = res.data.records;
          // this.queryApprovalProcessSwitch();
          this.$setStore("getWorkflowListTableData", this.tableData);
        });
      },
  
      // table button
      handleButton (val) {
        switch (val.methods) {
          case "handleEdit":
            this.handleEdit(val);
            break;
          case "handleDelete":
            this.handleDelete(val);
            break;
        }
      },
  
      // 分页
      handleSizeChange (val) {
        this.productTagPage.pageSize = val;
        this.productTagPage.pageNum = 1
        this.getWorkflowList();
      },
      handleCurrentChange (val) {
        this.productTagPage.pageNum = val;
        this.getWorkflowList();
      },
  
 

  
      // 审批流编辑
      handleEdit (val) {
        this.$router.push({
          path: "createApprove",
          query: {
            operateType:'edit',
            auditId:val.row.auditId,
            type:this.type
          },
        });
      },
      goToUrl (url) {
        // this.$store.state.tagsList.map((item, index) => {
        //             if (item.fullPath == this.$route.path) {
        //                 this.$store.state.tagsList.splice(index, 1);
        //             }
        //         })
        this.$router.push({ path: url, query: { type: this.type } });
        // this.$router.push({ path: url,query:{type:this.type} });
      },
  
      handleSortChange () { },

      //询比价选商定价审批
      async saveOrderAskPrice() {
        let res = await CompnanyApi.saveOrderAskPrice({
          data: '42',
        });
        if (res.code == '200') {
          // let message = val ? '审批流打开' : '审批流关闭';
          // this.$message.success(message);
        }
      },
      async saveApprovalSwitch(){
        let dataType = {
          '需求计划审批': 'orderDemand',
          '采购计划审批': "orderPlan",
          '询比价审批': 'orderAsk'
        }
        let res = await Api.saveApprovalProcessSwitch({
          dataType: dataType[this.title],
                  data: "42",
                });
                if (res.code == "200") {
                  // let message = "采购审批流关闭";
                  // this.$message.success(message);
                  // this.getWorkflowList();
                }
      }
      
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .pagination {
    text-align: right;
  }
  </style>
  